import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'textToCopy'];

  copy() {
    const text = this.textToCopyTarget.textContent;
    navigator.clipboard.writeText(text.trim())

    this.buttonTarget.dataset.bsOriginalTitle = this.buttonTarget.dataset.clipboardSuccessTextValue;
    this.toggleTooltip();
  }

  toggleTooltip() {
    this.tooltip = bootstrap.Tooltip.getInstance(this.buttonTarget);

    this.tooltip.show();

    setTimeout(() => {
      this.tooltip.hide()
    }, 2000)
  }
}
